import { ChangeDetectionStrategy, Component, input, OnDestroy, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-image-picker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, TranslatePipe],
  templateUrl: './image-picker.component.html',
})
export class ImagePickerComponent implements OnDestroy {
  readonly currentImageName = input<string | null>(null);
  readonly currentImageUrl = input<string | null>(null);

  readonly fileSelected = output<File>();

  readonly previewUrl = signal<string | null>(null);
  readonly pendingFile = signal<File | null>(null);

  onFileChange(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    const prev = this.previewUrl();
    if (prev) URL.revokeObjectURL(prev);
    this.pendingFile.set(file);
    this.previewUrl.set(URL.createObjectURL(file));
    this.fileSelected.emit(file);
  }

  clearPending(): void {
    const prev = this.previewUrl();
    if (prev) URL.revokeObjectURL(prev);
    this.previewUrl.set(null);
    this.pendingFile.set(null);
  }

  ngOnDestroy(): void {
    this.clearPending();
  }
}
